import React from "react";
import Square from "react-icons/lib/fa/square-o";
import Checked from "react-icons/lib/fa/check-square";
import './index.scss'

export default function Checkbox(props) {
  const { checked, disabled } = props;

  let className = "checkbox";
  if (checked) className += " checked";

  return <div className={className} style={props.style} onClick={onClick}>{checked ? <Checked /> : <Square />}</div>;

  function onClick() {
    if (disabled) return
    if (props.onClick) props.onClick()
  }
}

export function LanguageCheckbox(props) {
  const { label, checked, onClick } = props;

  let className = "language-checkbox";
  if (checked) className += " checked";

  return (
    <div className={className} onClick={onClick} style={props.style}>
      <div className="locale">{label}</div>
      <Checkbox checked={checked} style={{ fontSize: 20 }} />
    </div>
  );
}
